export const API_CONFIG = {
  BASE_URL: import.meta.env.VITE_API_BASE_URL ?? 'http://localhost:4600/api/v1',
  TIMEOUT: 30000,
} as const;

export const HANDLE_REGEX = /^[a-z0-9_]{3,30}$/;

export const API_ENDPOINTS = {
  AUTH: {
    SIGNUP: '/auth/signup',
    SIGNIN: '/auth/signin',
    VERIFY_OTP: '/auth/verify-otp',
    RESEND_OTP: '/auth/resend-otp',
    RESET_PASSWORD_REQUEST: '/auth/reset-password/request',
    RESET_PASSWORD_CONFIRM: '/auth/reset-password/confirm',
    REFRESH_TOKEN: '/auth/refresh-token',
    LOGOUT: '/auth/logout',
    GOOGLE: '/auth/google',
    EXCHANGE: '/auth/exchange',
  },
  USER: {
    ME: '/user/me',
    AVATAR: '/user/me/avatar',
    COVER: '/user/me/cover',
    DASHBOARD: '/user/me/dashboard',
    INSIGHTS: '/me/insights',
    HANDLE: '/user/handle',
    HANDLE_AVAILABLE: '/user/handle-available',
  },
  RELEASES: '/user/releases',
  EVENTS: '/user/events',
  LINKS: '/user/links',
  CONTACTS: '/user/contacts',
  FEEDBACK: '/user/feedback',
  PROFILES: (handle: string) => `/profiles/${handle}`,
} as const;

export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  SIGNUP: '/signup',
  FORGOT_PASSWORD: '/forgot-password',
  TERMS: '/terms',
  PRIVACY: '/privacy',
  GOOGLE_CALLBACK: '/auth/callback',
  ONBOARDING: '/onboarding',
  DASHBOARD: '/dashboard',
  DASHBOARD_ANALYTICS: '/dashboard/analytics',
  DASHBOARD_HIGHLIGHTS: '/dashboard/highlights',
  DASHBOARD_EVENTS: '/dashboard/events',
  DASHBOARD_SOCIALS: '/dashboard/socials',
  DASHBOARD_STREAMING: '/dashboard/streaming',
  DASHBOARD_CONTACT: '/dashboard/contact',
  DASHBOARD_SETTINGS: '/dashboard/settings',
  PROFILE: (slug: string) => `/${slug}`,
  STORE: (slug: string) => `/${slug}/store`,
  EXAMPLE: '/nestra',
} as const;
